/**
 * On-scroll reveal animations across Espace La Caverne pages.
 * Works alongside Dawn scroll-trigger when theme setting is enabled.
 */
(function () {
  const REVEAL_SELECTOR = [
    '.espace-home-intro',
    '.espace-collections__header',
    '.espace-collections__grid > li',
    '.espace-home-columns__grid > li',
    '.espace-home-columns .h2',
    '.product__info-container > *',
    '.product__accordion',
    '.product__description',
    '.collection-hero__inner',
    '.facets-wrapper',
    '#product-grid .grid__item',
    '.espace-footer__grid > *',
    '.espace-footer__bottom',
    '.espace-boutiques-hero',
    '.espace-boutiques-page .espace-boutique-card',
    '.espace-apropos-hero',
    '.espace-apropos-section',
    '.espace-apropos-stats',
    '.espace-collections__card',
    '.cart-items .cart-item',
    '.article-template__hero',
    '.article-template__content',
    '#MainContent .page-width > .rte',
    '.related-products .grid__item',
    '.template-search .grid__item',
  ].join(',');

  function shouldSkip(el) {
    if (!el || el.closest('.espace-home-hero')) return true;
    if (el.classList.contains('scroll-trigger')) return true;
    if (el.classList.contains('espace-reveal')) return true;
    if (el.closest('[hidden]')) return true;
    return false;
  }

  function markElements(root) {
    const scope = root || document;
    const nodes = scope.querySelectorAll(REVEAL_SELECTOR);
    let delayIndex = 0;

    nodes.forEach((el) => {
      if (shouldSkip(el)) return;
      el.classList.add('espace-reveal');
      if (el.matches('.espace-collections__grid > li, #product-grid .grid__item, .related-products .grid__item')) {
        el.style.setProperty('--espace-reveal-delay', `${(delayIndex % 8) * 0.06}s`);
        delayIndex += 1;
      }
    });
  }

  function observeReveals(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      (root || document).querySelectorAll('.espace-reveal').forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    (root || document).querySelectorAll('.espace-reveal:not(.is-revealed)').forEach((el) => observer.observe(el));
  }

  function init(root) {
    markElements(root);
    observeReveals(root);
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(root || document);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('facets:updated', () => {
    markElements(document.getElementById('ProductGridContainer') || document);
    observeReveals(document.getElementById('ProductGridContainer') || document);
  });
})();
